<template>
    <app-risk-analysis :the-client="client"/>
</template>

<script>
import RiskAnalysis from './RiskAnalysis.vue';
export default {
    components: {
        appRiskAnalysis: RiskAnalysis
    }
    
}
</script>
